import type { SVGProps } from 'react';

const SvgPlayerMixer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M10 6c0 .55.45 1 1 1h9c.55 0 1-.45 1-1s-.45-1-1-1h-9c-.55 0-1 .45-1 1m7 6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1M8 8V4c0-.55-.45-1-1-1s-1 .45-1 1v1H4c-.55 0-1 .45-1 1s.45 1 1 1h2v1c0 .55.45 1 1 1s1-.45 1-1m7 6v-4c0-.55-.45-1-1-1s-1 .45-1 1v1H4c-.55 0-1 .45-1 1s.45 1 1 1h9v1c0 .55.45 1 1 1s1-.45 1-1m-4 6v-4c0-.55-.45-1-1-1s-1 .45-1 1v1H4c-.55 0-1 .45-1 1s.45 1 1 1h5v1c0 .55.45 1 1 1s1-.45 1-1m2-2c0 .55.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1h-6c-.55 0-1 .45-1 1"
    />
  </svg>
);
export default SvgPlayerMixer;
